export const LOCALES = {
  uk: 'uk',
  ru: 'ru',
};

export const DEFAULT_LOCALE = LOCALES.uk;

export const LANGUAGES = {
  ua: 'ua',
  ru: 'ru',
};

export const DEFAULT_LANGUAGE = LOCALES.ru;
